<nz-form-control [class.large-form]="isWizard" class="text-input">
	<vaadin-date-picker class="ft-edit datepicker"
						[initialPosition]="initialDate"
						[ngModel]="value$ | async"
						(ngModelChange)="setValue($event)">
	</vaadin-date-picker>
</nz-form-control>